import initResetFilters from "./components/resetFiltersVanilla"

// Wait for DOM to be fully loaded
document.addEventListener('DOMContentLoaded', () => {
  initResetFilters();
});
